import React from 'react';
export function TopBar() {
  return <div className="w-full py-2.5 text-center" style={{
    backgroundColor: 'var(--color-deep-blue)'
  }} data-id="element-263">
      <p className="text-sm font-medium tracking-wide text-white/90" data-id="element-264">
        100% digital · Descarga inmediata · Material infantil
      </p>
    </div>;
}